export const leftToRight = "leftToRight";
export const rightToLeft = "rightToLeft";
